module.exports = __webpack_public_path__ + "static/media/submit-success.5eb2fbe6.png";